import uuid from 'uuid'

import { ErrorSettingsHelper } from './errors/settings'
import { TextSettingsHelper } from './text/settings'
import { isValidMode, VALIDATION_MODES } from './validators'

export const FIELDS = {
  DEFAULT_CHECKED: 'default_checked',
  DISABLED: 'disabled',
  HIDDEN: 'hidden',
  LIST: 'list',
  MODE: 'mode',
  REQUIRED: 'required',
}

export class ModeSettingsHelper extends TextSettingsHelper {
  _errors

  constructor(settings) {
    super(settings)

    this._settings = settings

    if (this.isModeSettingProcessable('required')) {
      this._errors = new ErrorSettingsHelper(
        this._settings.required.error_settings
      )
    }
  }

  get errors() {
    return this._errors
  }

  get hasDefaultChecked() {
    return this.isModeSettingProcessable('default_checked')
  }

  get isMandatoryChecked() {
    return (
      this._settings &&
      VALIDATION_MODES.MANDATORY_CHECKED === this._settings.mode
    )
  }

  get isRequired() {
    return this._settings && VALIDATION_MODES.REQUIRED === this._settings.mode
  }

  addIdsToSchemas(settings) {
    if (
      typeof settings !== 'object' ||
      Array.isArray(settings) ||
      settings === null
    ) {
      return
    }

    for (const key of Object.keys(settings)) {
      switch (key) {
        case FIELDS.DEFAULT_CHECKED:
        case FIELDS.DISABLED:
        case FIELDS.HIDDEN:
        case FIELDS.REQUIRED:
          this.addIdsToSchemas(settings[key])
          break

        case FIELDS.LIST:
          for (const item of settings[key]) {
            this.addIdsToSchemas(item)
          }
          break

        case FIELDS.MODE:
          if (VALIDATION_MODES.JSON_SCHEMA === settings[key]) {
            settings.schema.$id = uuid()
          }
          break

        default:
          break
      }
    }
  }

  isDefaultChecked(data) {
    if (!this.isModeSettingProcessable('default_checked')) {
      return false
    }

    return isValidMode(data, this._settings.default_checked)
  }

  isDisabled(data) {
    if (!this.isModeSettingProcessable('disabled')) {
      return false
    }

    return isValidMode(data, this._settings.disabled)
  }

  isHidden(data) {
    if (!this.isModeSettingProcessable('hidden')) {
      return false
    }

    return isValidMode(data, this._settings.hidden)
  }

  isModeSettingProcessable(key) {
    return (
      this._settings &&
      typeof this._settings[key] === 'object' &&
      typeof this._settings[key].mode === 'string' &&
      Object.values(VALIDATION_MODES).includes(this._settings[key].mode)
    )
  }

  isValid(data) {
    if (!this.isModeSettingProcessable('required')) {
      return true
    }

    return isValidMode(data, this._settings)
  }

  async setDefaultChecked(list, callback) {
    if (!this.hasDefaultChecked) {
      return
    }

    for (const item of list) {
      if (!this.isDefaultChecked(item)) {
        continue
      }

      callback && typeof callback === 'function' && (await callback(item))
    }
  }
}
